import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalCacheManager } from '../managers/local-cache.manager';
import { ApiUrlService } from './api-url.service';
import { ApiService } from './api.service';

@Injectable()
export class StationApiService extends ApiService
{

    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService,
                protected localCacheManager: LocalCacheManager)
    {
        super(http, localCacheManager);
    }

    testAllStations(controllerId: number, durationInMinutes: number, maxStations: number, includeDiagnostics: boolean = false)
    {
        return this.apiRequest(this.apiUrlService.getTestAllStationsUrl(controllerId, durationInMinutes, maxStations, includeDiagnostics), this.HttpMethod.Put);
    }

}
